import _objectSpread from "@babel/runtime-corejs3/helpers/objectSpread2";
import React, { useRef, useContext, useCallback, createContext, useDebugValue } from "react";
import omit from "lodash/omit";
import { useSyncExternalStore } from "use-sync-external-store/shim";
import { inBrowser, MemoryCache, mergeWithDefined } from "@lilib/utils";
var GLOBAL_CACHE_ID = "__LILIB_HOOKS_GLOBAL_CACHE__";
var defaultValue = {
  global: false,
  cacheTime: 5 * 60 * 1000,
  cacheSync: false
};
var CacheContext = /*#__PURE__*/createContext(_objectSpread(_objectSpread({}, defaultValue), {}, {
  cache: new MemoryCache()
}));
export var useCacheConfig = function useCacheConfig() {
  return useContext(CacheContext);
};
var CacheConfig = function CacheConfig(props) {
  var config = useCacheConfig();
  var cacheRef = useRef();
  var value = omit(props, "inherit", "children");
  if (props.inherit) {
    value = mergeWithDefined(config, value);
  } else {
    value = mergeWithDefined(defaultValue, value);
  }
  if (value.global && inBrowser && window[GLOBAL_CACHE_ID]) {
    value.cache = window[GLOBAL_CACHE_ID];
  }
  if (!value.cache) {
    if (!cacheRef.current) {
      cacheRef.current = new MemoryCache();
    }
    value.cache = cacheRef.current;
  }
  if (value.global && inBrowser && !window[GLOBAL_CACHE_ID]) {
    window[GLOBAL_CACHE_ID] = value.cache;
  }
  var cache = value.cache;
  var subscribe = useCallback(function (listener) {
    if (!cache.isReady()) {
      cache.once("ready", listener);
      return function () {
        cache.off("ready", listener);
      };
    } else {
      return function () {};
    }
  }, [cache]);
  var getSnapshot = useCallback(function () {
    return cache.isReady();
  }, [cache]);
  var ready = useSyncExternalStore(subscribe, getSnapshot);
  useDebugValue(ready ? "Ready" : "Unready");
  useDebugValue(value);
  return /*#__PURE__*/React.createElement(CacheContext.Provider, {
    value: value
  }, ready ? props.children : value.fallback);
};
CacheConfig.Context = CacheContext;
CacheConfig.useConfig = useCacheConfig;
export default CacheConfig;